import React, { useEffect } from "react";
import { BannerFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const BannerForm = ({
  initialValues,
  permission,
  onCancel,
  onDelete,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    img_file: yup.array().required("Required"),
    sequence: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" || originalValue === null ? null : value
      )
      .nullable()
      .typeError("กรุณากรอกตัวเลข")
      .integer("กรุณากรอกจำนวนเต็ม")
      .min(1, "ต้องมากกว่าหรือเท่ากับ 1"),
  });

  const {
    control,
    handleSubmit,
    watch,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
        img_file: initialValues.img_path
          ? [{ media_uri: initialValues.img_path }]
          : [],
        sequence: initialValues.sequence ?? "",
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const watchActionTypeField = watch("action_type");

  const _onSubmit = (values) => {
    let isErr = false;
    if (values.status === "2" && !values.rejection_reason) {
      isErr = true;
      setError("rejection_reason", {
        type: "custom",
        message: "Required",
      });
    }
    if (!isErr) {
      onSubmit(values);
    }
  };

  return (
    <BannerFormStyled>
      <form onSubmit={handleSubmit(_onSubmit)}>
        <div className="form_title">Banner</div>
        <div className="input_row">
          <div className="f_left_col">Banner Picture</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.UploadImage
                  {...field}
                  theme_upload_image
                  fieldName="img_path"
                  errors={errors.img_file?.message}
                />
              )}
              name="img_file"
              defaultValue=""
            />
            <div>***รูป JPG or PNG ขนาดกว้าง 428 px สูง 218 px</div>
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Redirect</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.Dropdown
                  {...field}
                  options={[
                    { label: "Activity", value: "1" },
                    { label: "News", value: "2" },
                    { label: "Online Form", value: "3" },
                    { label: "Product Warranty", value: "4" },
                    { label: "Etc", value: "5" },
                  ]}
                  errors={errors.action_type?.message}
                />
              )}
              name="action_type"
              // defaultValue={false}
            />
          </div>
        </div>
        {watchActionTypeField === "5" && (
          <div className="input_row">
            <div className="f_left_col">Url</div>
            <div className="f_right_col">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField {...field} errors={errors.url?.message} />
                )}
                name="url"
                defaultValue=""
              />
            </div>
          </div>
        )}
        <div className="input_row">
          <div className="f_left_col">ลำดับการแสดงผล</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField
                  {...field}
                  type="number"
                  min={1}
                  step={1}
                  placeholder="เช่น 1"
                  errors={errors.sequence?.message}
                />
              )}
              name="sequence"
              defaultValue=""
            />
            <div>***เลขน้อยแสดงก่อน ไม่ระบุจะแสดงท้ายสุด</div>
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Active</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_active?.message}
                />
              )}
              name="is_active"
              defaultValue={false}
            />
          </div>
        </div>
        <div className="cf_action_row">
          <div className="cf_action_item">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div>
          {initialValues && permission?.is_delete && (
            <div className="cf_action_item">
              <Buttons.BgStandard
                theme_red
                label="Delete"
                onClick={onDelete}
              />
            </div>
          )}
          <div className="cf_action_item">
            <Buttons.BgStandard
              type="submit"
              label="Update"
              // disabled={initialValues && initialValues.is_center}
            />
          </div>
        </div>
      </form>
    </BannerFormStyled>
  );
};

BannerForm.propTypes = {};

export default BannerForm;
